<template>
  <div style="margin-left:20px;padding: 20px;">
    <el-page-header @back="goBack" content="详情页面">
    </el-page-header>
    <el-row style="margin-top:20px;" :gutter="20">
      <el-col :span="8">
        <div>
          <el-card shadow="hover">
            <el-form class="refundInfo" label-position="left" label-width="120px">
              <h3 style="color:#808080">退货申请单</h3>
              <el-form-item label="售后单号">
                <el-input size="small" v-model="formLabelAlign.childOrderNo"></el-input>
              </el-form-item>
              <el-form-item label="售后类型">
                <el-button :disabled="true" v-if="formLabelAlign.type == 1" type="primary" size="small">退款</el-button>
                <el-button :disabled="true" v-if="formLabelAlign.type == 2" type="primary" size="small">退货</el-button>
                <el-button :disabled="true" v-if="formLabelAlign.type == 3" type="primary" size="small">换货</el-button>
              </el-form-item>
              <el-form-item label="发货状态">
                <el-button :disabled="true" v-if="formLabelAlign.productStatus == 1" type="primary" size="small">已收到货</el-button>
                <el-button :disabled="true" v-if="formLabelAlign.productStatus == 1" type="primary" size="small">未收到货</el-button>
              </el-form-item>
              <el-form-item label="退款金额">
                <el-input size="small" v-model="formLabelAlign.actualRefundAmount"></el-input>
              </el-form-item>
              <el-form-item label="退款数量">
                <el-input size="small" v-model="formLabelAlign.skuNumber"></el-input>
              </el-form-item>
              <el-form-item label="退款原因">
                <el-input size="small" v-model="formLabelAlign.reason"></el-input>
              </el-form-item>
              <el-form-item label="补充说明文案">
                <el-input size="small" v-model="formLabelAlign.reason"></el-input>
              </el-form-item>
              <el-form-item label="补充凭证">
               <img :src="formLabelAlign.pics">
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-col>
      <el-col :span="8">
        <div>
          <el-card shadow="hover">
            <el-form class="goodsInfo" label-position="left" label-width="120px">
              <h3 style="color:#808080">商品信息</h3>
              <el-form-item label="子订单号">
                <el-input size="small" v-model="formLabelAlign.childOrderNo"></el-input>
              </el-form-item>
              <el-form-item label="外部订单号">
                <el-input size="small" v-model="formLabelAlign.childOrderNo"></el-input>
              </el-form-item>
              <el-form-item label="商品名称">
                <el-input size="small" v-model="formLabelAlign.skuName"></el-input>
              </el-form-item>
              <el-form-item label="品牌">
                <el-input size="small" v-model="formLabelAlign.brandName"></el-input>
              </el-form-item>
              <el-form-item label="型号">
                <el-input size="small" v-model="formLabelAlign.modelCode"></el-input>
              </el-form-item>
              <el-form-item label="规格">
                <el-input size="small" v-model="formLabelAlign.skuSpecs"></el-input>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-col>
      <el-col :span="8">
        <div>
          <el-card shadow="hover">
            <el-form class="orderInfo" label-position="left" label-width="120px">
              <h3 style="color:#808080">下单信息</h3>
              <el-form-item label="联系人">
                <el-input size="small" v-model="formLabelAlign.receiverName"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input size="small" v-model="formLabelAlign.receiverPhone"></el-input>
              </el-form-item>
              <el-form-item label="收货地址">
                <el-input size="small" v-model="formLabelAlign.receiverAddress"></el-input>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px;" :gutter="20">
      <el-col :span="12">
        <div>
          <el-card shadow="hover">
            <el-form class="refundInfo" label-position="left" label-width="120px">
              <h3 style="color:#808080">物流轨迹(退货物流)</h3>
              <el-form-item label="发货物流公司">
                <el-input size="small" v-model="formLabelAlign.name"></el-input>
              </el-form-item>
              <el-form-item label="发货快递单号">
                <el-input size="small" v-model="formLabelAlign.region"></el-input>
              </el-form-item>
            </el-form>
            <div>
              <el-timeline :reverse="reverse">
                <el-timeline-item
                    v-for="(activity, index) in activities"
                    :key="index"
                    :timestamp="activity.timestamp">
                  {{ activity.content }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-card shadow="hover">
            <div class="block">
              <div style="margin-bottom: 40px;" class="radio">
                操作记录:
                <el-radio-group v-model="reverse">
                  <el-radio :label="true">售后记录</el-radio>
                  <el-radio :label="false">申诉记录</el-radio>
                </el-radio-group>
              </div>
              <el-timeline v-show="reverse">
                <el-timeline-item
                    v-for="(activity, index) in afterSalesRecords"
                    :key="index"
                    :timestamp="activity.createTime">
                  {{ activity.AuditNote }}
                </el-timeline-item>
              </el-timeline>

              <el-timeline v-show="!reverse">
                <el-timeline-item
                    v-for="(activity, index) in records"
                    :key="index"
                    :timestamp="activity.createTime">
                  {{ activity.AuditNote }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import {AfterSaleOrderAppealRecord, AfterSaleOrderAuditAppeal, AfterSaleOrderErpDetail} from "../../api/api";
import {OrderAfterSaleAppealRecord, OrderAfterSaleErpDetail} from "../../../api/api";

export default {
  name: "Detail",
  data() {
    return {
      afterSalesRecords:[],
      afterSaleOrderId: this.$route.query.afterSaleOrderId,
      formLabelAlign: {
        name: '啊实打实大',
        region: '啊实打实大',
        type: '啊实打实大',
        childOrderNo:'',
        receiverAddress:'',
        receiverPhone:'',
        receiverName:'',
        skuSpecs:'',
        modelCode:'',
        skuName:'',
        brandName:'',
        type: null,
        actualRefundAmount: null,
        skuNumber: null,
        reason: null,
        pics:null,
      },
      reverse: true,
      activities: [{
        content: '活动按期开始',
        timestamp: '2018-04-15'
      }, {
        content: '通过审核',
        timestamp: '2018-04-13'
      }, {
        content: '创建成功',
        timestamp: '2018-04-11'
      }],
      details:{},
      records:[],
      loading: false,
    }
  },
  created() {
    if (this.$route.query.afterSaleOrderId) {
      console.log('afterSaleOrderId', this.afterSaleOrderId)
      this.afterSaleOrderId = this.$route.query.afterSaleOrderId
      this.getDetail()
      this.getRecords()
    }
  },
  methods: {
    async getRecords(){
      let res = await OrderAfterSaleAppealRecord({afterSaleOrderId: this.afterSaleOrderId})
      console.log('jili', res);
      if (res.data.success) {
        this.records = res.data.response;
      }else{
        this.$message.error(res.data.msg);
      }
    },
    async getDetail() {
      let res = await OrderAfterSaleErpDetail({afterSaleOrderId: this.afterSaleOrderId})
      console.log('res', res);
      if (res.data.success) {
        this.formLabelAlign = res.data.result.data
        // if (res.data.result.data) {
        //   res.data.response.forEach((item)=> {
        //     this.afterSalesRecords.push({AuditTime:item.AuditNote,AuditNo:item.AuditNote})
        //   })
        // }
        console.log('this.afterSalesRecords', this.afterSalesRecords);
      }else{
        this.$message.error(res.data.msg);
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
/deep/ .refundInfo .el-input__inner {
  border: none;
}

/deep/ .refundInfo .el-form-item__label {
  color: #66b1ff;
  font-weight: bold;
}

/deep/ .goodsInfo .el-input__inner {
  border: none;
}

/deep/ .goodsInfo .el-form-item__label {
  color: #66b1ff;
  font-weight: bold;
}

/deep/ .orderInfo .el-input__inner {
  border: none;
}

/deep/ .orderInfo .el-form-item__label {
  color: #66b1ff;
  font-weight: bold;
}
</style>